/**
 * @generated SignedSource<<4c3cc97b7a2264729bbc251411f17997>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReceiverStoresSelector_receiverStores$data = ReadonlyArray<{
  readonly store: {
    readonly id: string;
    readonly name: string;
    readonly workspaceBreadcrumbs: ReadonlyArray<string>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ReceiverStoresSelectorListItem_receiverStore">;
  readonly " $fragmentType": "ReceiverStoresSelector_receiverStores";
}>;
export type ReceiverStoresSelector_receiverStores$key = ReadonlyArray<{
  readonly " $data"?: ReceiverStoresSelector_receiverStores$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReceiverStoresSelector_receiverStores">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ReceiverStoresSelector_receiverStores",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "includeExternalId",
              "value": true
            }
          ],
          "kind": "ScalarField",
          "name": "workspaceBreadcrumbs",
          "storageKey": "workspaceBreadcrumbs(includeExternalId:true)"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReceiverStoresSelectorListItem_receiverStore"
    }
  ],
  "type": "ReceiverStore",
  "abstractKey": null
};

(node as any).hash = "476f5059e9673399c7e58f6834af00fe";

export default node;
